/**
 * Formats a plain ISBN number (digits only) into the standard ISBN-13 format with dashes
 * @param isbn - The plain ISBN string containing only digits
 * @returns Formatted ISBN string in the format: 978 - 12 - 34 - 56789 - 0
 */
export function formatISBN(isbn: string): string {
  if (!isbn) return isbn;

  // If ISBN already has dashes, return as is
  if (isbn.includes("-")) return isbn;

  // Remove any non-digit characters
  const digits = isbn.replace(/\D/g, "");

  if (digits.length === 0) return "";

  // ISBN-13 structure: 978-12-34-56789-0 (3, 2, 2, 5, 1 digits)
  const parts = [3, 2, 2, 5, 1];
  let formatted = "";
  let index = 0;

  for (let i = 0; i < parts.length && index < digits.length; i++) {
    if (i > 0) formatted += " - ";
    formatted += digits.slice(index, index + parts[i]);
    index += parts[i];
  }

  return formatted;
}
